'use strict';

var moment = require('moment');

class Email {

    /**
     * @param {number} browserOffsetMS
     * @param {*} JSONData
     */
    constructor(browserOffsetMS, JSONData) {

        if (browserOffsetMS === undefined || JSONData === undefined) {
            throw new Error('browserOffsetMS and JSONData must be defined');
        }

        /**
         * @type {string}
         * @private
         */
        this._content = '';

        /**
         * @type {string}
         * @private
         */
        this._from_email = '';

        /**
         * @type {string}
         * @private
         */
        this._from_firstname = '';

        /**
         * @type {string}
         * @private
         */
        this._from_surname = '';

        /**
         * @type {string}
         * @private
         */
        this._from_initials = '';

        /**
         * @type {string}
         * @private
         */
        this._subject = '';

        /**
         * @type {array}
         * @private
         */
        this._attachments = [];

        /**
         * @type {string}
         * @private
         */
        this._timeInterval = '';

        /**
         * @type {boolean}
         * @private
         */
        this._displayed = false;

        /**
         * @type {boolean}
         * @private
         */
        this._read = false;

        /**
         * @type {Number}
         * @private
         */
        this._browserOffsetMS = browserOffsetMS;

        for (let property in JSONData) {
            let privatePropertyName = '_' + property;
            if (this.hasOwnProperty(privatePropertyName)) {
                if (JSONData.hasOwnProperty(property)) {
                    this[privatePropertyName] = JSONData[property];
                }
            } else {
                throw new Error('Unexpected parameter: "' + property + '"');
            }
        }
    }

    /**
     * @returns {string}
     */
    get content() {
        return this._content;
    }

    /**
     * @returns {string}
     */
    get from_email() {
        return this._from_email;
    }

    /**
     * @returns {string}
     */
    get from_firstname() {
        return this._from_firstname;
    }

    /**
     * @returns {string}
     */
    get from_surname() {
        return this._from_surname;
    }

    /**
     * @returns {string}
     */
    get from_initials() {
        return this._from_initials;
    }

    /**
     * @returns {string}
     */
    get subject() {
        return this._subject;
    }

    /**
     * @return {array}
     */
    get attachments() {
        return this._attachments;
    }

    /**
     * @return {boolean}
     */
    get displayed() {
        return this._displayed;
    }

    /**
     * @param {boolean} displayed
     */
    set displayed(displayed) {
        this._displayed = displayed;
    }
    
    /**
     * @return {boolean}
     */
    get read() {
        return this._read;
    }

    /**
     * @param {boolean} read
     */
    set read(read) {
        this._read = read;
    }

    /**
     * @return {string}
     */
    get preview() {
        let strippedContent = this._content.replace(/<(?:.|\n)*?>/gm, ' ').replace(/\s\s+/g, ' ').trim();
        let brutallyTruncatedContent = strippedContent.substr(0, 150);
        // Re-trim to ensure no partial words at end...
        return brutallyTruncatedContent.substr(
            0,
            Math.min(brutallyTruncatedContent.length, brutallyTruncatedContent.lastIndexOf(" "))
        );
    }

    /**
     * @return {boolean}
     */
    get hasAttachments() {
        return (this._attachments.length > 0);
    }

    /**
     * @returns {boolean}
     */
    get isUnread() {
        return (this._read === false);
    }

    get timeIntervalMoment() {
        return moment.duration(this._timeInterval);
    }

    /**
     * @param {Moment} scheduleStartDateTime
     * @return {Moment}
     */
    timeToDisplay(scheduleStartDateTime) {
        let timeIntervalMoment = moment.duration(this._timeInterval);
        return moment(scheduleStartDateTime).add(timeIntervalMoment);
    }

    /**
     * @param {Moment} scheduleStartDateTime
     * @return {boolean}
     */
    isReadyToDisplay(scheduleStartDateTime) {
        let adjustedNow = moment().add(this._browserOffsetMS, 'ms');
        return this.timeToDisplay(scheduleStartDateTime).isSameOrBefore(adjustedNow);
    }

    /**
     * @param {Moment} scheduleStartDateTime
     * @return {string}
     */
    messageListDateString(scheduleStartDateTime) {
        return this.timeToDisplay(scheduleStartDateTime).format('MMM D YYYY : HH:mm');
    }

    /**
     * @param {Moment} scheduleStartDateTime
     * @return {string}
     */
    fullDateString(scheduleStartDateTime) {
        return this.timeToDisplay(scheduleStartDateTime).format('dddd, Do MMMM [at] HH:mm');
    }
}

module.exports = Email;



// WEBPACK FOOTER //
// ./assets/vue/objects/Email.js